import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ArrowLeft , ArrowRight } from "lucide-react";
import { Container , Card } from "react-bootstrap";
import image1 from './images/1986e12ac72dfd3526acc9f3437b7727.webp'
import image2 from './images/authentic-indian-tray-with-traditional-sacred-objects-wedding-ceremony.webp'
import image3 from './images/1314923-bathu.webp'
import image4 from './images/realistic-people-celebrating-gudi-padwa.webp'
import image5 from './images/wellness-practices-self-care-world-health-day.webp'
import image6 from './images/indian-family-gathering-celebration-festival-lifestyle_1000823-115452.webp'
import image7 from './images/medium-shot-people-celebrating-tamil-new-year.webp'
import Image8 from './images/close-up-decorative-sculptures.webp'



const culturalHighlights = [
  {
    title: "Traditional Values",
    description:
      "Celebrating the timeless values of integrity, compassion, and respect that strengthen family and community ties .",
    image: image1,
  },
  {
    title: "Sacred Rituals",
    description:
      "Preserving the sanctity of rituals that connect generations through devotion and shared spiritual heritage.",
    image: image2,
  },
  {
    title: "Festive Celebrations",
    description:
      "Marking every occasion with color, music, and joy — creating memories that bond families together.",
    image: image3,
  },
  {
    title: "Cultural Knowledge",
    description:
      "Encouraging the pursuit of wisdom through literature, language, and arts rooted in our cultural ethos.",
    image: image4,
  },
  {
    title: "Spiritual Harmony",
    description:
      "Promoting mindfulness, meditation, and connection with the divine essence through daily practices.",
    image: image5,
  },
  {
    title: "Community Gatherings",
    description:
      "Fostering unity and togetherness through cultural programs, events, and family interactions.",
    image: image6,
  },
  {
    title: "Cuisine & Hospitality",
    description:
      "Celebrating the art of traditional cooking and the warmth of hospitality that defines our culture.",
    image: image7,
  },
  {
    title: "Art & Heritage",
    description:
      "Honoring the crafts, temples, and music that form the foundation of our artistic and spiritual expression.",
    image: Image8,
  },
];

const ImageSwiper = () => {
  return (
    <Container className="image-swiper-container">
      <h2 style={{ color :'#ff8a00', fontSize :"clamp(2rem , 5vw , 3rem )" , fontWeight :'bold'}}>Traditions That Bind Generations</h2>
      <p style={{ fontWeight :'500' , fontSize : 'clamp(1rem , 5vw , 1.5rem)'}}>Where culture meets togetherness in every step of life.</p>
      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={1}
        
        breakpoints={{
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4 },
        }}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
        className="custom-swiper"
      >
        {culturalHighlights.map((culture , i) => (
          <SwiperSlide key={i}>
            <Card className="slide-card">
              <Card.Body>
                <Card.Img variant="top" src={culture.image || 'https://via.placeholder.com/150'} alt ='culture-image' className="card-img" />
                <Card.Text className="card-title mt-3 mb-3" style={{ color :' #e52e71' }} >{culture.title}</Card.Text>
                <Card.Text >{culture.description}</Card.Text>
              </Card.Body>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div className="swiper-controls">
        <button className="custom-prev" ><ArrowLeft size={30}/></button>  
        <button className="custom-next"><ArrowRight size={30} /></button>
      </div>
    </Container>
  );
};

export default ImageSwiper;
